var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsulationTopCeiling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 21590 27940",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_868819168"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M4368 21250l13225 0 10 4493 -13235 0 0 -4493zm28 -5166l0 0 13197 0 0 4549 -13225 0c0,-361 28,-619 28,-983l0 -3566zm0 -649l0 0 28 -4630 13141 0 41 4661 -13210 -31zm6599 -12829l0 0 7918 7000 668 576 -17177 -5c2848,-2518 5728,-5078 8591,-7571zm-9772 7918l0 0c0,387 680,281 1152,281 477,0 954,0 1432,0l-56 10530 -2275 0c-68,0 -196,128 -196,196 0,108 -43,393 280,393l2191 0 0 3847 -2275 0c-255,0 -293,562 28,562l16735 0 -28 -5083 1292 0c398,0 358,-589 0,-589l-1292 0 -28 -9856c395,0 2239,51 2443,-56 246,-127 146,-371 -88,-557l-9045 -7971c-548,-533 -438,-528 -1277,252l-8748 7706c-102,85 -245,213 -245,345z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fil1",
    points: "18913,9606 3054,9603 2404,10177 19581,10182 ",
    fill: "#FDD625"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsulationTopCeiling);
export default __webpack_public_path__ + "static/media/insulation-top-ceiling.584f90b44fbd5569e8212ff84e47faa7.svg";
export { ForwardRef as ReactComponent };